export default [
    { key: "name", description: "اسم کلاینت", value: "TeamspeakUser" },
    {
        key: "date",
        description: "تاریخ",
        value: "1404/12/03",
        faValue: "۱۴۰۴/۱۲/۰۳",
        numericType: "en",
    },
    { key: "clock", description: "ساعت", value: "12:33", faValue: "۱۲:۳۳", numericType: "en" },
    {
        key: "sgOnlines",
        description: "انلاین های یک یا چند رنک",
        faValue: "۲۲",
        value: "22",
        numericType: "en",
    },
    {
        key: "clients",
        description: "انلاین های سرور",
        value: "128",
        faValue: "۱۲۸",
        numericType: "en",
    },
    {
        key: "clVersion",
        description: "ورژن کلاینت",
        value: "3.5.6",
        faValue: "۳.۵.۶",
        numericType: "en",
    },
    {
        key: "srvUpTime",
        description: "آپتایم سرور به روز",
        value: "85",
        faValue: "۸۵",
        numericType: "en",
    },
    { key: "srvPing", description: "پینگ سرور", value: "45", faValue: "۴۵", numericType: "en" },
    {
        key: "temp",
        description: "دمای شهر به درجه",
        value: "36",
        faValue: "۳۶",
        numericType: "en",
    },
    {
        key: "rs-grade",
        description: "گرید کلاینت",
        value: "🗿 Grade 1",
    },
    {
        key: "rs-top-1",
        description: "اسم نفر برتر 1",
        value: "TOPUSER1",
    },
    {
        key: "rs-top-2",
        description: "اسم نفر برتر 2",
        value: "TOPUSER2",
    },
    {
        key: "rs-top-3",
        description: "اسم نفر برتر 3",
        value: "TOPUSER3",
    },
    {
        key: "rs-top-4",
        description: "اسم نفر برتر 4",
        value: "TOPUSER4",
    },
    {
        key: "rs-top-5",
        description: "اسم نفر برتر 5",
        value: "TOPUSER5",
    },
    {
        key: "rs-top-6",
        description: "اسم نفر برتر 6",
        value: "TOPUSER6",
    },
    {
        key: "rs-top-7",
        description: "اسم نفر برتر 7",
        value: "TOPUSER7",
    },
    {
        key: "rs-top-8",
        description: "اسم نفر برتر 8",
        value: "TOPUSER8",
    },
    {
        key: "rs-top-9",
        description: "اسم نفر برتر 9",
        value: "TOPUSER9",
    },
    {
        key: "rs-top-10",
        description: "اسم نفر برتر 1",
        value: "TOPUSER1",
    },
]
